// packages
import { Row, Col, Form } from 'react-bootstrap';

// components

// api

// styles
import './FooterLP.scss';

const FooterLP = () => {
  return (
    <>
      <section className='footerUP'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 contact-us'>
              <h3 className='text-white mb-3'>Have questions? Contact Us!</h3>
            </div>
            <div className='col-lg-6'>
              <form>
                <div className='row'>
                  <div className='col-lg-5 col-8 mb-2 '>
                    <Form.Group>
                      <Form.Control placeholder='Enter Your Email Address' />
                    </Form.Group>
                  </div>
                  <div className='col-lg-5 col-8 mb-2'>
                    <Form.Group>
                      <Form.Control placeholder='Type Your Message' />
                    </Form.Group>
                  </div>
                  <div className='col-lg-2 col-12 mb-2 '>
                    <button className='btn px-3 py-3 '>Send</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div className='footerLP'>
        <div className='container'>
          <Row>
            <Col md>
              <div>
                <img
                  alt='img'
                  className='container'
                  src='./footerlogo.png'
                />
              </div>
            </Col>
            <Col md>
              <div>
                <p className='footer-title'>Republic of the Philippines</p>
                <p>All content is in the public domain unless otherwise stated.</p>
              </div>
            </Col>
            <Col md>
              <div>
                <p>About GOVPH</p>
                <p>
                  Learn more about the Philippine Government, its structure, how government works and the people behind
                  it.
                </p>
              </div>
            </Col>
            <Col md>
              <div>
                <p>Government Links</p>
                <a
                  href='#'
                  className='link'
                >
                  Office of the President
                </a>
                <a
                  href='#'
                  className='link'
                >
                  Office of the Vice-President
                </a>
                <a
                  href='#'
                  className='link'
                >
                  Senate of the Philippines
                </a>
                <a
                  href='#'
                  className='link'
                >
                  House of Representatives
                </a>
                <a
                  href='#'
                  className='link'
                >
                  Supreme Court
                </a>
                <a
                  href='#'
                  className='link'
                >
                  Court of Appeals
                </a>
                <a
                  href='#'
                  className='link'
                >
                  Sandiganbayan
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className='copyright'>
        <div className='container'>
          <div className='d-flex justify-content-between '>
            <p className='nopadding'>© 2022 PHILIPPINE NATIONAL POLICE</p>
            <p className='nopadding'>
              <u>Terms of Use</u> | <u>Privacy Policy</u>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterLP;
